import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '../config'

Vue.use(VueRouter)

/*
  路由懒加载
*/
const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/workwxHome.vue')
    // component: () => import('../views/home.vue')
  },
  {
    path: '/main',
    name: 'home',
    component: () => import('../views/home.vue')
  },
  {
    path: '/uploadProof',
    name: 'uploadProof',
    component: () => import('../views/uploadProof.vue')
  },
  {
    path: '/progressQuery',
    name: 'progressQuery',
    component: () => import('../views/progressQuery.vue')
  },
  {
    path: '/getCoupons', // 选课流程页面
    name: 'getCoupons',
    component: () => import('../views/getCoupons.vue')
  },
  {
    path: '/buyClass', // 筛选完成后的课程列表
    name: 'buyClass',
    component: () => import('../views/buyClass.vue')
  },
  {
    path: '/payPage', // 去支付页面
    name: 'payPage',
    component: () => import('../views/payPage.vue')
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('../views/mobile.vue')
  },
  {
    path: '/submitSuccess', // 提交成功页
    name: 'submitSuccess',
    component: () => import('../views/submitSuccess.vue')
  },
  // {
  //   path: '/sharePoster', // 分享海报
  //   name: 'sharePoster',
  //   component: () => import('../views/sharePoster.vue')
  // },
  {
    path: '/errorPage', // 报错页面
    name: 'errorPage',
    component: () => import('../views/errorPage.vue')
  },
  {
    path: '/workwxHome',
    redirect: { name: 'main' }
  },
  {
    path: '/workwxHint',
    name: 'workwxHint',
    component: () => import('../views/workwxHint.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log('scrollBehavior', to)
    // return 期望滚动到哪个的位置
    if (to.name === 'home' && savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  console.log('to', to)
  console.log('from', from)
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  if (!isMobile && to.name !== 'mobile') {
    next({ name: 'mobile' })
  }
  if (isMobile && to.name === 'mobile') {
    next({ name: 'main' })
  }
  next()
})

router.afterEach((to) => {
  document.title = to.meta.title || '五月献礼人民教师'
  const pageConfig = config.xesLog.pages[to.name]
  if (pageConfig) {
    setTimeout(() => {
      /*
        每个页面配置统一的 pageuid、pagename、pagelevel
        页面中发埋点日志时，不需要再单独配置如上参数
      */
      Vue.prototype.$xesLogger.opts.param.pageuid = pageConfig.uid
      Vue.prototype.$xesLogger.opts.param.pagename = pageConfig.name
      Vue.prototype.$xesLogger.opts.param.pagelevel = pageConfig.level

      // 进入页面时发送展现日志
      // Vue.prototype.$xesLogger.loadMsg()
    }, 300)
  }
  /**
     * app内头部设置
     */
  const params = {
    title: '五月献礼人民教师',
    // action_icon: ''
    action_icon: 'https://xesfile.xesimg.com/biz-growth-storage/activity/upload/20201119/e63f152da217bf71666073133ee43a75.png'
  }
  window.callbackSetTitleBar = () => {
    function configAppShare(mark) {
      const shareConfig = {
        shareType: 1, // 1.网页，2大图，3小程序 // 分享类型，默认h5链接
        agentKey: '', // 项目日志自定义统计key
        shareScence: 31, // 分享渠道,二进制转换 000000 ~ 111111。 timeline
        businessId: 2018, // 项目对于业务ID
        isOneKeyShare: false, // 是否一键分享,有多种分享渠道时应置为false
        title: '五月献礼人民教师',
        actionUrl: 'https://t.xueersi.com/gR9thMU6', // 跳转url, 域名应以http或https开头开头
        description: '新华网五一起送全国教师子女，由学而思网校提供的暑假系统课',
        imagePath: 'https://editor.xesimg.com/tailor/resource/%E7%BB%8455-1619440728820.png' // 图片地址
      }
      window.appShareBack = () => {
        this.$xesLogger.clickMsg({
          params: {
            clickid: mark,
            clicklevel: 1,
            action: 'appShareBack',
            clickname: '分享回调'
          }
        })
      }
      xesApp.start('xesShare/share', JSON.stringify(shareConfig), 'appShareBack')
    }
    configAppShare(2.4)
  }
  window.xesApp && window.xesApp.start('setTitleBar', JSON.stringify(params), 'callbackSetTitleBar')
})
export default router
